import { css, unsafeCSS } from 'lit';
import { HEADER_HEIGHT, MOBILE_BREAKPOINT, FONT_FAMILY, COLOR_SIGNOUT, COLOR_ACTIVE, COLOR_HOVER, COLOR_BUTTON_BLUE, SUBHEADER_DROPDOWN_ANIMATION_DURATION } from './constants.js';

const headerHeight = unsafeCSS(`${HEADER_HEIGHT}px`);
const mobileBreakpoint = unsafeCSS(`${MOBILE_BREAKPOINT}px`);
const fontFamily = unsafeCSS(FONT_FAMILY);
const colorSignout = unsafeCSS(COLOR_SIGNOUT);
const colorActive = unsafeCSS(COLOR_ACTIVE);
const colorHover = unsafeCSS(COLOR_HOVER);
const colorButtonBlue = unsafeCSS(COLOR_BUTTON_BLUE);
const subheaderDropdownAnimationDuration = unsafeCSS(`${SUBHEADER_DROPDOWN_ANIMATION_DURATION}ms`);

export const DxoStyles = css`
  .dxo-ui-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  .primary-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 40px;
    height: ${headerHeight};
    position: relative;
    z-index: 1001;
    background-color: #013D5B;
    white-space: nowrap;
  }

  .header-logo-link {
    color: white;
    text-decoration-color: white;
  }

  .header-logo {
    max-height: 40px;
  }

  .header-tabs {
    display: flex;
    gap: 32px;
    margin-left: 64px;
    margin-right: auto;
  }

  .header-tab-link {
    font-family: ${fontFamily};
    font-size: 14px;
    font-weight: 500;
    color: white;
    text-decoration: none;
    white-space: nowrap;
  }

  .header-tab-link:hover {
    color: #337eac;
  }

  .header-tab-link.active {
    font-weight: 600;
  }

  .login-button {
    background-color: #ffffff;
    color: #e3245a;
    font-family: ${fontFamily};
    border: solid 1px #e3245a;
    border-radius: 0.875rem;
    text-align: center;
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
    cursor: pointer;
    transition: all ease-in-out 50ms;
    text-decoration: none;
  }

  .login-button:hover {
    color: white;
    background-color: #e3245a;
  }

  .profile-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #D9EBED;
    color: #1B6587;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${fontFamily};
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
  }

  .profile-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .profile-container:after {
    content: '';
    position: absolute;
    top: 100%;
    left: -50;
    width: 100px;
    height: 20px;
    visibility: hidden;
  }

  .profile-container:hover:after {
    cursor: pointer;
    visibility: visible;
  }

  .profile-container .profile-picture {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 2rem;
    width: 2rem;
    object-fit: cover;
  }

  .profile-container .profile-picture img {
    width: 2rem;
    height: 2rem;
  }

  .profile-img {
    width: 2rem;
    height: 2rem;
  }

  .profile-container .dropdown-arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.5rem;
  }

  .profile-container:hover .logout-dropdown {
    display: flex;
  }

  .logout-dropdown {
    display: none;
    flex-direction: column;
    gap: 16px;
    position: absolute;
    min-width: 10rem;
    width: fit-content;
    background-color: white;
    padding: 16px;
    border-radius: 6px;
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.2));

    top: 50px;
    right: 0;
    font-family: ${fontFamily};
  }

  .logout-dropdown-header {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    width: 100%;
    text-decoration: none;
  }

  .logout-dropdown-name {
    margin: 0;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    font-family: ${fontFamily};
    color: black;
  }

  .dropdown-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 32px;
    font-family: ${fontFamily};
    font-size: 14px;
    font-weight: 600;
    color: ${colorButtonBlue};
    text-decoration: none;
    text-align: center;
    border: 1px solid ${colorButtonBlue};
    border-radius: 4px;
    box-sizing: border-box;
  }

  .dropdown-button-signout {
    color: ${colorSignout};
    border-color: ${colorSignout};
    background-color: white;
    cursor: pointer;
  }

  ::slotted([slot="header-slot"]) {
    width: 25vw;
    margin-left: auto;
  }

  .auth-actions {
    margin-left: 20px;
  }

  .subheader {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 64px 0 64px;
    height: 48px;
    background-color: white;
    z-index: 1000;
    box-shadow: inset 0 -1px 0 #C9CED2;
  }

  .subheader-tab {
    flex: 1;
    display: flex;
    align-items: center;
    height: 48px;
    font-weight: 500;
    font-family: ${fontFamily};
    font-size: 13px;
    padding-left: 16px;
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    color: inherit;

    &.active {
        box-shadow: inset 0 -4px 0 ${colorActive};
    }

    &:not(.active):hover {
        box-shadow: inset 0 -2px 0 ${colorHover};
    }
  }

  .subheader-dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(4px);
    background-color: rgba(1, 1, 1, 0.25);
    z-index: 999;
  }

  @keyframes dropDown {
    0% {
      opacity: 0;
      transform: translateY(-10px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .drop-down {
    animation: dropDown ${subheaderDropdownAnimationDuration} ease-out forwards;
  }
  
  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  
  .fade-in {
    animation: fadeIn ${subheaderDropdownAnimationDuration} ease-in forwards;
  }

  .subheader-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    z-index: 1000;
  }

  .subheader-dropdown-content {
    display: flex;
    align-items: stretch;
    gap: 10px;
    padding: 0 64px;
  }

  .subheader-dropdown-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 8px 0 16px 16px;
  }

  .subheader-dropdown-link {
    display: flex;
    align-items: center;
    font-family: ${fontFamily};
    font-size: 12.5px;
    color: black;
    text-decoration: none;
    padding: 8px 0;
    width: 100%;
  }

  .subheader-dropdown-link span {
    position: relative;
  }

  .subheader-dropdown-link:hover {
    color: ${colorHover};
  }

  .subheader-dropdown-link:hover span::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -8px;
    width: 100%;
    height: 1px;
    background-color: ${colorHover};
  }

  .subheader-dropdown-link.active {
    color: ${colorActive};
  }

  .mobile-button {
    display: none;
    fill: white;
    cursor: pointer;
  }

  .mobile-search-button {
    display: none;
    background: none;
    border: none;
    cursor: pointer;
    color: white;
    fill: white;
  }

  @media screen and (max-width: ${mobileBreakpoint}) {
    .primary-header.mobile-padding {
      padding: 0 16px;
    }

    .mobile-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: ${headerHeight};
      background: none;
      border: none;
    }

    .mobile-logo {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .hide-for-mobile {
      display: none;
    }

    .mobile-search-button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 16px;
    }

    .header-slot.slot-open {
      display: flex;
      flex: 1;
      width: 100%;
    }

    .mobile-button.slot-open {
      display: none;
    }

    .mobile-logo.slot-open {
      display: none;
    }

    .slot-open::slotted([slot="header-slot"]) {
      width: 100%;
    }
  }
`;